<script>
	import { createEventDispatcher, onMount, afterUpdate } from 'svelte';
	import { fade } from 'svelte/transition';
	import Identity from 'svelte-key'
	import { person, open, logOut, helpCircleOutline, addCircleOutline, settings as settingsIcon, cube, map, headset, videocam, document, link, bookmark, refresh, image } from 'ionicons/icons/index.mjs';
	import { projectSort } from '../shared/utils/Sort.svelte';
	import { fetchData, getLocalServer, getMessages, addMessages, loadMessages, setMessageSync, getMessageSync} from '../shared/utils/Data.svelte';

	export let vitals;
	export let content;
	export let projects;
	export let keys;
	export let tooltips;
	//export let messages;
	export let settings;
	export let session;

	let messages = [];
	let tab = "projects";
	let filter = "";
	let loaded = false;

	onMount(async () => {  
			loadMessages(session.id, async function (result) {
				loaded = true;
				messages = result;
				let lastSync = getMessageSync();
				console.log(lastSync);
				let [res, err] = await fetchData("/v1/messages?last=" + lastSync, {
					headers: {
						"Authorization": "Bearer " + session.token
					}
				})
				if (!err && res.data && res.data.messages && res.data.messages.length > 0) {
						addMessages(res.data.messages);
						setMessageSync(new Date().getTime());
				}
				messages = getMessages();
			});
	});

	afterUpdate(() => {  
		if (loaded) {
			messages = getMessages();
		}
	});

	const dispatch = createEventDispatcher();
	function sendMessage(message) {
		dispatch('message', message);
	}
	function filterHandler() {
		sendMessage({
			type: "filter"
		})
	}
</script>

<div id="tree" class="panel">
	<div class="panel-header p-2">
		<div class="btn-group btn-group-block">
			<button class="btn btn-sm {tooltips ? "tooltip tooltip-bottom" : ""} {tab == "projects" ? "active" : ""}" data-tooltip="Projects" on:click|stopPropagation={(e) => {
                tab = "projects";
			}}>Projects</button>
			<button class="btn btn-sm {tooltips ? "tooltip tooltip-bottom" : ""} {tab == "messages" ? "active" : ""}" data-tooltip="Messages"  on:click|stopPropagation={(e) => {
                tab = "messages";
			}}>Messages</button>
		</div> 
	</div>
	<div class="panel-body">
		{#if tab == "projects"}
		<div>
			<div id="filterContainer" class="tile tile-centered pr-2 pl-2">
				<div class="tile-content">
					<div class="form-group pb-1">
						<label class="form-label" for="projectFilter">Filter</label>
						<input class="form-input" type="text" id="projectFilter" oninput={filterHandler} bind:value={filter}>
					</div>
				</div>
			</div>
			{#if projects && projects.length > 0}
				<Identity key={keys.project}>
					{#each projects.filter(p => p.name.toLowerCase().startsWith(filter.toLowerCase())).sort(projectSort) as project}
						<ul class="menu menu-nav" in:fade>
							<div class="tile tile-centered">
								<div class="tile-content">
									<li class="menu-item {content.id == project.id ? "active" : ""}"><button class="btn btn-link" on:click={(e) => {
										e.currentTarget.blur();
										sendMessage({
											type: "content",
											data: {
												view: "project",
												id: project.id,
												name: project.name
											}
										})
										var url = window.location.origin + "?p=" + project.id;
										history.replaceState("", "", url);
									}}>{project.name}</button></li>
								</div>
							</div>
						</ul>
					{/each}
				</Identity>
			{/if}
		</div>
	{:else if tab == "messages"}
		<div>
				<button class="btn btn-primary p-1" style="width:100%;" on:click|stopPropagation={(e) => {
						e.currentTarget.blur();
						sendMessage({
								type: "modal",
								data: {
										view: "message"
								}
						})
				}}>New Message</button>
				{#if messages}
						{#each messages as item}
								<div class="tile tile-centered pr-2 pl-2">
										<div class="tile-content">
												<div class="tile-title">{ item.subject }</div>
												<div class="tile-subtitle text-gray">{new Date(item.timestamp).toLocaleDateString() + " " + new Date(item.timestamp).toLocaleTimeString()}</div>
										</div>
										<div class="tile-action">
												<button class="btn btn-link {tooltips ? "tooltip tooltip-left" : ""}" data-tooltip="Open" on:click|stopPropagation={(e) => {
																		e.currentTarget.blur();
																		sendMessage({
																				type: "modal",
																				data: {
																						view: "messageView",
																						content: item.body,
																						message: item,
																						id: item.id
																				}
																		})
																}}>
														<i class="svg">{@html open.md}</i>
												</button>
										</div>
								</div>
						{/each}
				{/if}
		</div>
	{/if}
	</div>
	<div class="panel-footer">
	<div class="tile tile-centered">
			<div class="tile-content">
				<div class="btn-group slant slant-right-reverse">
					<button class="btn btn-link {tooltips ? "tooltip tooltip-right" : ""}" data-tooltip="Settings" on:click={(e) => {
					e.currentTarget.blur();
					sendMessage({
						type: "modal",
						data: {
								view: "settings"
						}
					})
					}}><i class="svg svg-light">{@html settingsIcon.md}</i></button>
					<button class="btn btn-link {tooltips ? "tooltip tooltip-right" : ""}" data-tooltip="Sign Out" on:click={(e) => {
					e.currentTarget.blur();
					sendMessage({
						type: "session",
						data: {
							workspaces: ""
						}
					})
					}}><i class="svg svg-light">{@html logOut.md}</i></button>
					<button class="btn btn-link {tooltips ? "tooltip tooltip-right" : ""}" data-tooltip="Help" on:click={async (e) => {
						e.currentTarget.blur();
						if (window.platform == "Windows") {
							await fetch(getLocalServer() + "/help")
						}
						else {
							window.open("https://help.geosync.cloud");
						}
					}}><i class="svg svg-light">{@html helpCircleOutline.md}</i></button>
				</div>
			</div>
			<div class="tile-action version">
					{ vitals.version }
			</div>
		</div>
	</div>
</div>

<style>
	.version {
		font-size: 80%;
		margin-top: 15px;
		margin-right: 5px;
	}
    #tree {
        position: fixed;
        overflow-y: auto;
        width: 300px;
        height: 100%;
	}
	#filterContainer {
		margin-top: -0.6rem;
	}
	.form-group {
		margin: 0;
	}
	.panel {
        border: 0;
	}
	.panel .panel-footer {
		padding: 0;
		background: #efefef;
	}
	.menu {
        padding: 0 0 0 0.8rem;
    }
    .menu .menu-item {
        padding: 0;
    }
	.menu .menu-item > button {
		border: 0;
	}
	::-webkit-scrollbar {
		width: 6px;
		background-color: #f7f8f9;
	}
	::-webkit-scrollbar-thumb {
		background-color: rgba(122,129,132, 1);
	}
	.menu-item.active {
		color: #00ab5f;
	}
	.svg {
		fill: #00ab5f;
	}
	.slant {
		color: white;
		background-color: #00ab5f;
		transform-origin: bottom left;
		position: relative;
		z-index: 1;
	}
	.slant-right-reverse:before {
		content: "";
		position: absolute;
		z-index: -1;
		top: 0;
		bottom: 0;
		right: 0;
		width: 20px;
		margin-right: -10px;
		background-color: #00ab5f;
		border-right: 2px solid #a9d9bb;
		-ms-transform: skew(30deg, 0deg);
		-webkit-transform: skew(30deg, 0deg);
		transform: skew(30deg, 0deg);
	}
	.slant .btn.btn-link {
		color: white;
	}
</style>
